<script>
</script>

<div class="info-box-container">
  <slot />
</div>

<style>
  .info-box-container {
    padding: var(--spacing-8) var(--spacing-8);
    background: var(--color-gray-shade-lightest);
  }
</style>
